import { closeEmailModal } from '../State/emailModal'

export default () => (dispatch) => {

  dispatch(closeEmailModal())

}
